import { z } from 'zod'

import { afterValid } from '~/services/api/contracts/afterValid'
import { email } from '~/services/api/contracts/email'
import { fileUpload } from '~/services/api/contracts/fileUpload'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { phone } from '~/services/api/contracts/phone'
import { ProfileUpdateRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const MARKUP = /[<>]/

const normalize = fieldNormalizer({
  trimmed: ['name', 'last_name', 'email'],
  blankToNull: ['phone', 'timezone']
})

const DashboardUpdateProfileSchema = ProfileUpdateRequestSchema.omit({
  has_custom_permissions: true,
  organizer_account_id: true,
  partner_id: true,
  permissions: true,
  roles: true,
  status: true,
  managed_stores: true
}).extend({
  avatar: fileUpload({ mimes: ['jpeg', 'png', 'jpg', 'gif', 'webp'], maxKb: 5120 }).optional(),
  email: email(255).optional(),
  last_name: z.string().min(1).max(255).optional(),
  name: z.string().min(1).max(255).optional(),
  phone: phone.nullish()
})

export const DashboardUpdateProfile = (_context: NoContext = {}) =>
  z.preprocess(
    normalize,
    afterValid(DashboardUpdateProfileSchema, (value, ctx) => {
      if (typeof value.name === 'string' && MARKUP.test(value.name)) {
        ctx.addIssue({
          code: 'custom',
          message: 'The name must not contain markup',
          path: ['name']
        })
      }
      if (typeof value.last_name === 'string' && MARKUP.test(value.last_name)) {
        ctx.addIssue({
          code: 'custom',
          message: 'The last name must not contain markup',
          path: ['last_name']
        })
      }
    })
  )
